import React, {createContext, Dispatch} from "react";
import { SystemMessageModel } from "../models/SystemMessageModel";

export type ApplicationContextType = {
    message: SystemMessageModel | null
    setMessage: Dispatch<React.SetStateAction<SystemMessageModel | null>>
    setErrMessage: (msg: string) => void,
    setSuccessMessage: (msg: string) => void,
    setWarningMessage: (msg: string) => void,
    setInfoMessage: (msg: string) => void,
}
const ApplicationContext = createContext<ApplicationContextType | undefined>(undefined);
export default ApplicationContext


